import { connect } from 'react-redux';

import * as CliApp from 'app/entities/CliApp';
import * as CliAppDefinition from 'app/entities/CliAppDefinition';
import * as DeveloperActions from 'app/developer-v3/Actions';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import hocify from 'app/common/components/hocify';
import { FORM_TYPES } from 'app/developer-v3/constants';
import { formFields } from 'app/developer-v3/selectors';
import { parseBackendAppToAppType } from 'app/developer-v3/utils';

import CreateIntegrationPage from './CreateIntegrationPage';

import type { NewAppFormType } from 'app/developer-v3/types';

const mapStateToProps = state => {
  const actualFormFields = formFields(state, FORM_TYPES.newApp);
  const integrations = CliApp.selectors.all
    .entitiesData(state)
    .map(parseBackendAppToAppType);

  return {
    countIntegrations: integrations.length,
    formFields: actualFormFields,
    isLoading:
      CliApp.selectors.all.isLoading(state) || actualFormFields.length === 0,
    isSaving:
      CliApp.selectors.all.isSavingAny(state) ||
      CliAppDefinition.selectors.all.isSavingAny(state),
  };
};

const mapDispatchToProps = dispatch => ({
  onLoad() {
    dispatch(CliApp.actions.loadCollectionWithParams({ full: true }));
    dispatch(DeveloperActions.getAppFormFields('create'));
  },
  async onSubmit(integrationSettings: NewAppFormType) {
    return dispatch(DeveloperActions.createNewApp(integrationSettings));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(hocify(LoadingBlockOrComponent)(CreateIntegrationPage));
